/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Draft_Row_AddedInputs */

const en_us2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Joins ${i?.session}`)
};

const pt_br2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra no ${i?.session}`)
};

const es_419_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra en ${i?.session}`)
};

const pt_pt2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra no ${i?.session}`)
};

const fr_fr2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entre dans ${i?.session}`)
};

const de_de2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neu in ${i?.session}`)
};

const it_it2_draft_row_added = /** @type {(inputs: Draft_Row_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entra in ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Joins {session}" |
*
* @param {Draft_Row_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_row_added = /** @type {((inputs: Draft_Row_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Row_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_row_added(inputs)
	if (locale === "es-419") return es_419_draft_row_added(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_row_added(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_row_added(inputs)
	if (locale === "de-DE") return de_de2_draft_row_added(inputs)
	if (locale === "it-IT") return it_it2_draft_row_added(inputs)
	return en_us2_draft_row_added(inputs)
});
export { draft_row_added as "draft.row_added" }